module.exports = __webpack_public_path__ + "static/media/ic-checked.56b1237b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-checked.svg
// module id = 650
// module chunks = 0